import React from "react";
import { Row, Col, Table, Typography, Space } from "antd";
import LogoForPDF from "../../../svg/svgicon/LogoForPDF";
import DocumentIcon from "../../../svg/svgicon/DocumentIcon";
import { API } from "../../../API/API";

const { Text } = Typography;
const Str = require('@supercharge/strings');

class JoinWorkToPDF extends React.Component {
  state = {
    joinworkcode: "",
    joinworkname: "",
    tendertypename: null,
    departmentname: null,
    startdate: null,
    enddate: null,
    note: "",
    worklocation: "",
    workduration: "",
    status: 0,
    data: null,
    joinworkid: this.props.joinworkid,
    product_requirement: "",
    owner_products_supply: "",
    criterialist: [],
    requirelist: [],
    email: "",
    address: "",
    phone: "",
    tenderdoclist: [],
    tasklist: [],
    commentlist: [],
    post: "",
    electron: "",
    text: [],
    dkey: 1,
    stage: 1,
  };
    
  getData = () => {
    API.get("/getJoinWorkDtl?joinworkid=" + this.state.joinworkid).then(
      (response) => {
        if (response.status === 200) {
          this.setState({
            tendertypelist: response.data.retData[0],
            deplist: response.data.retData[1],
          });
          // eniig zasna
          if (response.data.retData[2].length > 0) {
            this.setState((prevState) => ({
              joinworkcode: response.data.retData[0][0].joinworkcode,
              joinworkname: response.data.retData[0][0].joinworkname,
              tendertypename: response.data.retData[0][0].tendertypename,
              departmentname: response.data.retData[0][0].departmentname,
              tendertypeid: response.data.retData[0][0].tendertypeid,
              departmentid: response.data.retData[0][0].departmentid,
              startdate: response.data.retData[0][0].startdate,
              enddate: response.data.retData[0][0].enddate,
              worklocation: response.data.retData[0][0].worklocation,
              workduration: response.data.retData[0][0].workduration, 
              note: response.data.retData[0][0].note,
              status: response.data.retData[0][0].statusname,
              product_requirement: response.data.retData[0][0].product_requirement,
              owner_products_supply: response.data.retData[0][0].owner_products_supply,
              criterialist: response.data.retData[1],
              requirelist: response.data.retData[2],
              address:
                response.data.retData[3].length > 0
                  ? response.data.retData[3][0].address
                  : "",
              email:
                response.data.retData[3].length > 0
                  ? response.data.retData[3][0].email
                  : "",
              phone:
                response.data.retData[3].length > 0
                  ? response.data.retData[3][0].phone
                  : "",
              electron:
                response.data.retData[3].length > 0
                  ? response.data.retData[3][0].electron === 1
                    ? "Цахим"
                    : ""
                  : "",
              post:
                response.data.retData[3].length > 0
                  ? response.data.retData[3][0].post === 1
                    ? "Хаягаар ирүүлэх"
                    : ""
                  : "",
              tenderdoclist: response.data.retData[4],
              tasklist: response.data.retData[5],
              commentlist: response.data.retData[6],
              dkey: prevState.dkey + 1,
            }));
          }
        }
      }
    );
  };

  componentDidMount = () => {this.getData();};
  
  render() {
    const columnCriteria = [
      {
        title: "№",
        dataIndex: "index",
        key: "index",
        width: "5%",
        align: "left",
        className:"left-side-label",
        render: (text, row, index) =>(
          <>{this.state.criterialist.indexOf(row) +1}</>
          )
      },
      {
        title: "Шалгуурын төрөл",
        key: "criteriatypename",
        width: "35%",
        align: "left",
        backgroundColor: "gray",
       
        render: (text, row, index) =>(
          <div style={{ height: '100%', display: 'flex', alignItems: 'flex-start' }}>
          {row.criteriatypename + ': ' + row.criterianame}</div>
          )
      },
      {
        title: "Бүрдүүлэх материалууд",
        key: "requirelist",
        width: "55%",
        align: "left",
        render: (text, row) => {
          // Filter requirelist for current row's criteriaid
          const relatedItems = this.state.requirelist.filter(
            item => item.criteriaid === row.criteriaid
          );
          return (
            <ul>
              {relatedItems.map((item, idx) => (
                <li key={idx}>{item.requirevalue}</li> // Adjust `item.name` based on actual field
              ))}
            </ul>
          );
        }
      }
    ];

    const columnTask = [
      {
        title: "№",
        dataIndex: "index",
        key: "index",
        width: "5%",
        align: "left",
        className:"left-side-label",
        render: (text, row, index) =>(
          <>{this.state.tasklist.indexOf(row) +1}</>
          )
      },
      {
        title: "Хийгдэх ажил",
        dataIndex: "taskname",
        key: "taskname",
        width: "35%",
        align: "left",
        backgroundColor: "gray"
      },
      {
        title: "Тайлбар",
        dataIndex: "taskdetail",
        key: "taskdetail",
        width: "60%",
        align: "left",
      },
    ];
    return (
      <div style={{ padding: 10 }} key={this.state.dkey} id="printOf">
      <div style={{ backgroundColor: "#fff" }}>
        <Row justify="center" align="middle">
          <Col style={{ marginTop: -20, marginRight: 20 }}>
            <LogoForPDF />
          </Col>
          <Col>
            <div className="PDFHeaderLabel">MONGOLYN ALT (MAK)</div>
          </Col>
        </Row>
        <Row style={{ marginTop: -10 }} justify="center">
          <div className="PDFSubHeaderLabel">CORPORATION</div>
        </Row>
        <Row style={{ marginTop: 20 }} justify="center">
          <div className="PDFTitleLabel">{this.state.joinworkname}</div>
        </Row>
        <Row style={{ marginTop: 15 }} justify="center">
          <div style={{ padding: 10 }}>
            <div className="PDFContentLabel" style={{ marginBottom: 10 }}>
              <b>Зорилго:</b>&nbsp;{this.state.note}
            </div>
            <div>
              <Row gutter={(16, 16)}>
                <Col className="headerTable-leftSide" span={12}>
                  <div className="headerTable-leftSide-Text">Захиалагч:</div>
                </Col>
                <Col className="headerTable-rightSide" span={12}>
                  <div className="headerTable-rightSide-Text">
                    Монголын алт ХХК - Хангамж техник үйлчилгэээний газар
                  </div>
                </Col>
                <Col className="headerTable-leftSide" span={12}>
                  <div className="headerTable-leftSide-Text">
                    Хамтран ажиллах саналын дугаар:
                  </div>
                </Col>
                <Col className="headerTable-rightSide" span={12}>
                  <div className="headerTable-rightSide-Text">
                    {this.state.joinworkcode}
                  </div>
                </Col>
              </Row>
              <Row gutter={(16, 16)}>
                <Col className="headerTable-leftSide" span={12}>
                  <div className="headerTable-leftSide-Text">Ажил гүйцэтгэх байршил:</div>
                </Col>
                <Col className="headerTable-rightSide" span={12}>
                  <div className="headerTable-rightSide-Text">{this.state.worklocation}</div>
                </Col>
                <Col className="headerTable-leftSide" span={12}>
                  <div className="headerTable-leftSide-Text">Ажил хийгдэх хугацаа:</div>
                </Col>
                <Col className="headerTable-rightSide" span={12}>
                  <div className="headerTable-rightSide-Text">{this.state.workduration}</div>
                </Col>
              </Row>
              <div className="content-Text-Bold" style={{ marginTop: 15 }}>
                ХИЙГДЭХ АЖЛУУД
              </div>
              <div>
                  <Table
                    dataSource={this.state.tasklist}
                    columns={columnTask}
                    pagination={false}
                    rowKey="docid"
                    width="99%"
                    style={{padding: '0 !important'}}
                  />
              </div>
              { this.state.product_requirement ? 
              <div style={{ marginTop: 15 }}>
                <div className="content-Text-Bold">БАРААНЫ ШААРДЛАГА:</div>
                <div className="content-Text" style={{ marginTop: 10, marginLeft: 10, whiteSpace: 'pre-line'}}>
                  {this.state.product_requirement}
                </div>
              </div> : null }
              { this.state.owner_products_supply ? 
              <div style={{ marginTop: 15 }}>
                <div className="content-Text-Bold">ЗАХИАЛАГЧААС НИЙЛҮҮЛЭХ БАРАА, ҮЙЛЧИЛГЭЭ:</div>
                <div className="content-Text" style={{ marginTop: 10, marginLeft: 10, whiteSpace: 'pre-line'}}>
                  {this.state.owner_products_supply}
                </div>
              </div> : null}
              <div className="content-Text-Bold" style={{ marginTop: 15 }}>
                КОМПАНИД ТАВИГДАХ ШААРДЛАГА
              </div>
              {/* {this.state.criterialist.map((el, index) => (
                <div
                  key={index}
                  className="content-Text"
                  style={{ marginLeft: 10 }}
                >
                  {index + 1}. {el.criteriatypename}
                </div>
              ))}
              <div className="content-Text-Bold" style={{ marginTop: 15 }}>
                БҮРДҮҮЛЭХ МАТЕРИАЛЫН ЖАГСААЛТ
              </div> */}
              <div style={{ marginTop: 15 }}>
                  <Table
                    dataSource={this.state.criterialist}
                    columns={columnCriteria}
                    pagination={false}
                    rowKey="docid"
                    width="99%"
                    style={{padding: '0 !important'}}
                  />
              </div>
              <div style={{ marginTop: 20 }}>
                <text style={{ fontWeight: 700 }}>
                  Хамтран ажиллах саналын материалыг
                </text>{" "}
                {this.state.enddate} хүртэл{" "}
                {this.state.electron !== "" && this.state.post !== ""
                  ? this.state.electron +
                    " болон " +
                    this.state.post +
                    " хэлбэрээр "
                  : this.state.electron !== "" || this.state.post !== ""
                  ? this.state.electron + " " + this.state.post + " хэлбэрээр https://tender.mak.mn вэб хуудсаар"
                  : null}{" "}
                хүлээн авна. 
              </div>
              <div className="content-Text-Bold" style={{ marginTop: 15 }}>
                Хаяг :{" "}
                <text style={{ fontWeight: 400 }}>{this.state.address}</text>
              </div>
              <div className="content-Text-Bold" style={{ marginTop: 15 }}>
                И-мэйл:{" "}
                <text style={{ fontWeight: 400 }}>{this.state.email}</text>
              </div>
              <div className="content-Text-Bold" style={{ marginTop: 15 }}>
                Вэб сайт: <text style={{ fontWeight: 400 }}>www.mak.mn</text>
              </div>
              <div className="content-Text-Bold" style={{ marginTop: 15 }}>
                Утас:{" "}
                <text style={{ fontWeight: 400 }}>{this.state.phone}</text>
              </div>
            </div>
          </div>
        </Row>
      </div>
    </div>
    );
  }
}

export default JoinWorkToPDF;
